import { createRoutes } from 'shared/hocs'

import { AthletesOverview } from './overview'
import { AthletesAdd } from './overview/components/add'
import { AthletesUpdate } from './overview/components/update/container'

export const Athletes = createRoutes(({ match }) => [
  {
    exact: true,
    path: `${match.path}/edit`,
    component: AthletesAdd,
  },
  {
    path: `${match.path}/edit/:athleteId`,
    component: AthletesUpdate,
  },
  {
    exact: true,
    path: match.path,
    component: AthletesOverview,
  },
])
